import { applicationCapabilitiesStore } from "../ApplicationCapabilitiesStore";
import { getAllowedValue } from "../capabilityLookup";
import {} from "@next-platform/packages-ts-types";
import { useCallback, useRef } from "react";
import { useSyncExternalStore } from "use-sync-external-store/shim";
const emptyAllowedValues = [];
const getFalseServerSnapshot = () => false;
const getAllowedArrayServerSnapshot = () => emptyAllowedValues;
export function useApplicationCapabilitiesAllowed(keyOrKeys) {
    const isArrayInput = Array.isArray(keyOrKeys);
    const refKeys = useRef(isArrayInput ? keyOrKeys : []);
    const refPreviousResult = useRef([]);
    const keysString = JSON.stringify(isArrayInput ? keyOrKeys : []);
    const refPrevKeysString = useRef(keysString);
    if (refPrevKeysString.current !== keysString) {
        refKeys.current = isArrayInput ? keyOrKeys : [];
        refPreviousResult.current = [];
        refPrevKeysString.current = keysString;
    }
    const getSingleSnapshot = useCallback(() => getAllowedValue(keyOrKeys), [keyOrKeys]);
    const getArraySnapshot = useCallback(() => {
        const nextResult = refKeys.current.map((key) => getAllowedValue(key));
        const previousResult = refPreviousResult.current;
        if (previousResult.length === nextResult.length && previousResult.every((value, index) => value === nextResult[index])) {
            return previousResult;
        }
        refPreviousResult.current = nextResult;
        return nextResult;
    }, []);
    const getSnapshot = isArrayInput ? getArraySnapshot : getSingleSnapshot;
    return useSyncExternalStore(applicationCapabilitiesStore.subscribe, getSnapshot, isArrayInput ? getAllowedArrayServerSnapshot : getFalseServerSnapshot);
}
